var map = {
	"./slider-img1.jpg": 1159,
	"./slider-img10.jpg": 1160,
	"./slider-img11.jpg": 1161,
	"./slider-img12.jpg": 1162,
	"./slider-img13.jpg": 1163,
	"./slider-img14.jpg": 1164,
	"./slider-img15.jpg": 1165,
	"./slider-img16.jpg": 1166,
	"./slider-img17.jpg": 1167,
	"./slider-img18.jpg": 1168,
	"./slider-img19.jpg": 1169,
	"./slider-img2.jpg": 1170,
	"./slider-img20.jpg": 1171,
	"./slider-img21.jpg": 1172,
	"./slider-img22.jpg": 1173,
	"./slider-img23.jpg": 1174,
	"./slider-img24.jpg": 1175,
	"./slider-img3.jpg": 1176,
	"./slider-img4.jpg": 1177,
	"./slider-img5.jpg": 1178,
	"./slider-img6.jpg": 1179,
	"./slider-img7.jpg": 1180,
	"./slider-img8.jpg": 1181,
	"./slider-img9.jpg": 1182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1158;